export default {
  getActiveStepForm: state => state.activeStepForm,
  allLinks: state => JSON.parse(state.allLinks),
  withoutYoutube: state =>
    JSON.parse(state.allLinks).filter(link => link.name !== 'Youtube')
}
